module.exports = __webpack_public_path__ + "static/media/TLQ_2160.9834d999.jpg";